import(/* webpackMode: "eager" */ "/src/app/newsletter/page.tsx");
